export default {
    topics: [
        {
            title: ' IncreaseValue ',
            href: 'sm-counter-IncreaseValue.html',
            attributes: { 'data-id': 'sm-counter-IncreaseValue' },
            menu: { hasChildren: false },
            tocID: 'sm-counter-IncreaseValue-d66e401',
            topics: [],
        },
    ],
};

